import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import MerchantAssociationInactiveView from './MerchantAssociationInactiveView';

const { Links } = deriveLinkComponents(
  MerchantAssociationInactiveView,
  api.getZMSAMMerchant,
);

export default Links;
